export default __webpack_public_path__ + "static/media/restore-bg.8da4ff6f.png";